import React, { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";

function BasicInfo(props) {
  const { nextStep, prevStep } = props;
  const {
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
    getValues,
  } = useFormContext();

  

 

  return (
    <>
      <div className="w-full space-y-5">
        <div className="space-y-5">
          <div className="space-y-8 mt-4">
            <div>
              <label className="text-lg text-gray-500">Client Name *</label>
              <input
                type="text"
                name="client_name"
                placeholder="Write your name "
                className="outline-none border-b w-full py-2 text-sm"
                {...register("client_name", {
                  required: "Client name is required.",
                       validate: (v) =>
      v.trim() !== "" || "Client name is required.",  
                })}
              />
              {errors.client_name && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.client_name.message}
                </p>
              )}
            </div>
            <div>
              <label className="text-lg text-gray-500">Email *</label>

              <input
                type="text"
                name="email"
                placeholder=" Write your email "
                className="outline-none border-b w-full py-2 text-sm"
                 {...register("email", {
                    required: "Email is required.",
                    pattern: {
                      value: /\S+@\S+\.\S+/,
                      message: "Enter a valid email.",
                    },
                  })}
              />
              {errors.email && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.email.message}
                </p>
              )}
            </div> 
            <div>
              <label className="text-lg text-gray-500">Contact Number *</label>

              <input
                type="text"
                name="contact_number"
                placeholder="Enter  contact number  "
                className="outline-none border-b w-full py-2 text-sm"
               {...register("contact_number", {
                    required: "Phone number is required.",
                      pattern: {
                      value: /^[0-9]+$/,
                      message: "Phone number must contain only digits.",
                    },
                    minLength: {
                      value: 8,
                      message: "Phone number must be at least 8 digits.",
                    },
                    maxLength: {
                      value: 15,
                      message: "Phone number must be at most 15 digits.",
                    },
                  
                  })}
              />
              {errors.contact_number && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.contact_number.message}
                </p>
              )}
            </div>
            <div>
              <label className="text-lg text-gray-500">Business Name *</label>
              
              <input
                type="text"
                name="business_name"
                placeholder="Write your business name  "
                className="outline-none border-b w-full py-2 text-sm"
                {...register("business_name", {
                  required: "Business name is required.",
                       validate: (v) =>
      v.trim() !== "" || "Business name is required.",  
                  
                })}
              />
              {errors.business_name && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.business_name.message}
                </p>
              )}
            </div>
            <div>
              <label className="text-lg text-gray-500">Industry</label>

              <input
                type="text"
                name="industry "
                placeholder="Mention industry"
                className="outline-none border-b w-full py-2 text-sm"
                {...register("industry")}
              />
            
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center">
          <button
            className=" bg-[#FFC067] font-bold  rounded px-6 py-3 text-base md:text-lg hover:bg-[#DF73FF]  transition ease-in duration-300 cursor-pointe text-dark "
            onClick={async () => {
              const isValid = await trigger([
                "client_name",
                "email",
                "contact_number",
              ]);
              if (isValid) {
                nextStep();
                     if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
              }
            }}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
}

export default BasicInfo;
